import axios from "axios";

export class CommonAPIService {
  constructor() {
    this.api_url = process.env.VUE_APP_API_URL;
    this.ai_url = process.env.VUE_APP_AI_URL;
    this.llm_url = process.env.VUE_APP_LLM_URL;
    this.loggedIn = false;
  }

  getAuthHeaders() {
    const token =
      sessionStorage.getItem("signUpToken") || localStorage.getItem("jwtToken");
    return token ? { Authorization: `${token}` } : {};
  }

  newFileCall(url, formData) {
    const fullUrl = this.api_url + url;
    return axios
      .post(fullUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          ...this.getAuthHeaders(),
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  login(login, router, store, errors) {
    return axios
      .post(`${this.api_url}/api/auth/login`, login)
      .then((response) => {
        localStorage.setItem("jwtToken" + "", response.data.token);
        sessionStorage.removeItem("signUpToken");
        store.setUser(response.data.user);
        store.setLoggedIn(true);
        const appScopes = [];
        for (const auth_group of response.data.user.auth_groups) {
          for (const scope of auth_group.scopes) {
            appScopes.push(scope);
          }
        }
        store.setAppScopes(appScopes);
        if (appScopes.some((scope) => scope.name === "settings")) {
          store.setViewSettings(true);
        }
        return response.data;
      })
      .catch((e) => {
        errors.push(e);
        if (e.response.status === 401) {
          router.push({
            name: "Login",
          });
        }
        return { success: false, msg: "Login Failure" };
      });
  }

  generateOTP(parameters, router) {
    axios.defaults.headers.common.Authorization =
      localStorage.getItem("jwtToken");
    const fullUrl = `${this.api_url}/api/auth/generate-otp`;
    return axios
      .get(fullUrl, parameters)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          router.push({
            name: "Login",
          });
        }
        throw error;
      });
  }

  verifyOTP(parameters, router) {
    axios.defaults.headers.common.Authorization =
      localStorage.getItem("jwtToken");
    const fullUrl = `${this.api_url}/api/auth/verify-otp`;
    return axios
      .post(fullUrl, parameters)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          router.push({
            name: "Login",
          });
        }
        throw error;
      });
  }

  postCall(url, parameters, router) {
    const fullUrl = this.api_url + url;
    return axios
      .post(fullUrl, parameters, { headers: this.getAuthHeaders() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          router.push({ name: "Login" });
        }
        throw error;
      });
  }

  fileCall(url, files, router) {
    const fullUrl = this.api_url + url;
    return axios
      .post(fullUrl, files, {
        headers: {
          "Content-Type": "multipart/form-data",
          ...this.getAuthHeaders(),
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          router.push({ name: "Login" });
        }
        throw error;
      });
  }

  deleteCall(url, parameters, router) {
    const fullUrl = this.api_url + url;
    return axios
      .delete(fullUrl, { data: parameters, headers: this.getAuthHeaders() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          router.push({ name: "Login" });
        }
        throw error;
      });
  }

  putCall(url, parameters, router) {
    const fullUrl = this.api_url + url;
    return axios
      .put(fullUrl, parameters, { headers: this.getAuthHeaders() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          router.push({ name: "Login" });
        }
        throw error;
      });
  }

  getCall(url, parameters, router) {
    const fullUrl = this.api_url + url;
    return axios
      .get(fullUrl, { params: parameters, headers: this.getAuthHeaders() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          router.push({ name: "Login" });
        }
        throw error;
      });
  }
}

export default CommonAPIService;
